<template>
  <div :class="$style.base">
    <Flex
      direction="column"
      :class="$style.items"
      :gap="0.5"
    >
      <template
        v-for="row in rows"
        :key="row.key"
      >
        <ServicePackageItem
          v-if="row.kind === 'package'"
          :name="row.name"
          :serviceNames="row.serviceNames"
          :quantity="row.quantity"
          :price="row.price"
          :originalPrice="row.originalPrice"
          :discountPercentage="row.discountPercentage"
        />
        <OrderItem
          v-else
          :item="row.item"
        />
      </template>
    </Flex>
    <div :class="$style.total">
      <BaseHeading size="s">{{ $t('global.total') }}</BaseHeading>
      <BaseText
        bold
        v-test="'register-payment-total-price'"
      >
        {{ filters.currency(totalPrice) }}
      </BaseText>
    </div>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import filters from '@/filters';
import { useOrderSummaryRows } from '@/helpers/order-summary-rows';
import { useRegisterOrderStore } from '@/modules/register/stores/order';
import OrderItem from './OrderItem.vue';
import ServicePackageItem from './ServicePackageItem.vue';

const { order, totalPrice } = storeToRefs(useRegisterOrderStore());

const rows = useOrderSummaryRows(() => order.value.items);
</script>

<style
  lang="scss"
  module
>
.base {
  padding: $spacing;
}

.items {
  margin-bottom: $spacing * 2;
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
